import { render } from "./single-package-seating-chart.vue?vue&type=template&id=1c0f04a4"
import script from "./single-package-seating-chart.vue?vue&type=script&lang=js"
export * from "./single-package-seating-chart.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__